import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { AlloyButton, Checkbox, CheckboxGroup } from 'cat-ecommerce-alloy';
import { UOM } from '@app/constants/commonConstants';
import useAnalytics from '@app/hooks/useAnalytics/useAnalytics';
import { setPLPQueryParam } from '@app/store/plp/actions';
import usePagination from '../../../usePagination/usePagination';

const BucketCheckbox = ({
  isEditing,
  isModal,
  setIsEditing,
  setSearch,
  setShowInput
}) => {
  const [t] = useTranslation();

  const { setUrlToPageOneWithFilter } = usePagination();
  const { dispatchWithImpressionEvent } = useAnalytics();

  const activeFacets = useSelector(s => s.plpUI.activeFacets);
  const bucketModelActiveFacet = useSelector(
    s => s.plpUI.bucketModelActiveFacet
  );

  const checkboxHandleChange = ({ target: { checked } }) => {
    const newActiveFacets = checked
      ? activeFacets.concat({
          facet: bucketModelActiveFacet?.facet,
          label: bucketModelActiveFacet?.label,
          uom: UOM.null
        })
      : activeFacets.filter(
          ({ facet }) => facet !== bucketModelActiveFacet?.facet
        );

    dispatchWithImpressionEvent(
      setPLPQueryParam({ activeFacets: newActiveFacets })
    );

    setUrlToPageOneWithFilter({ facets: newActiveFacets });
  };

  const changeButtonHandleClick = () => {
    !isEditing ? setShowInput(true) : setShowInput(false);
    setSearch(bucketModelActiveFacet?.label);
    setIsEditing(!isEditing);
  };

  // setChecked prop is required in order to control the checkbox state
  const setChecked = () => {};
  return (
    <>
      {!isEditing && (
        <CheckboxGroup
          className="mb-3"
          label={t('BUCKET_MODEL_NO')}
          onChange={checkboxHandleChange}
          showOptional
        >
          <Checkbox
            aria-label="bucketCheckboxInput"
            checked={activeFacets
              ?.map(({ facet }) => facet)
              .includes(bucketModelActiveFacet?.facet)}
            className="ms-2"
            data-testid="bucketModelCheckbox"
            // The checkbox component needs a unique id, currently we are rendering the same component
            // in desktop and mobile modal, that's why we need to pass the isModal prop
            // to know if the checkbox is rendered in desktop or mobile version.
            id={`${bucketModelActiveFacet?.label}-${
              bucketModelActiveFacet?.facet
            }-${isModal ? 'desktop' : 'mobile'}`}
            label={bucketModelActiveFacet?.label}
            name={bucketModelActiveFacet?.label}
            setChecked={setChecked}
            value={[
              bucketModelActiveFacet?.facet,
              bucketModelActiveFacet?.label
            ]}
          />
        </CheckboxGroup>
      )}
      <AlloyButton
        buttonType="ghost"
        className="ps-0"
        onClick={changeButtonHandleClick}
        type="button"
      >
        {isEditing ? t('CANCEL') : t('CHANGE')}
      </AlloyButton>
    </>
  );
};

BucketCheckbox.propTypes = {
  isEditing: PropTypes.bool,
  isModal: PropTypes.bool,
  setIsEditing: PropTypes.func,
  setSearch: PropTypes.func,
  setShowInput: PropTypes.func
};

export default BucketCheckbox;
